import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-slate-950 pt-24 pb-12 border-t border-white/5" data-id="element-40">
      <div className="container mx-auto px-6" data-id="element-41">
        <div className="grid lg:grid-cols-4 gap-12 mb-20" data-id="element-42">
          <div className="lg:col-span-2" data-id="element-43">
            <a href="#" className="mb-8 block" data-id="element-44">
              <img src="https://cdn.magicpatterns.com/uploads/eGy4RwjVoVa91269krSrRo/pasted-image.png" alt="Deskmayte Logo" className="h-10 w-auto brightness-0 invert" data-id="element-45" />
            </a>
            <p className="text-slate-400 text-lg max-w-md mb-8" data-id="element-46">
              Stop managing operations and start building your business. Let us
              be the extension that drives your growth.
            </p>
            <div className="flex gap-4" data-id="element-47">
              {[Linkedin, Twitter, Instagram].map((Icon, i) => <a key={i} href="#" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-accent hover:text-brand-dark transition-all" data-id="element-48">
                  <Icon className="w-5 h-5" data-id="element-49" />
                </a>)}
            </div>
          </div>

          <div data-id="element-50">
            <h4 className="text-white font-bold mb-6" data-id="element-51">Services</h4>
            <ul className="space-y-4 text-slate-400" data-id="element-52">
              <li data-id="element-53">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-54">
                  Digital Marketing
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-56">
                  Lead Generation
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-58">
                  Cold Outreach
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-60">
                  HRaaS & Staffing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-61">
            <h4 className="text-white font-bold mb-6" data-id="element-62">Contact</h4>
            <ul className="space-y-4 text-slate-400" data-id="element-63">
              <li className="flex items-center gap-3" data-id="element-64">
                <Mail className="w-5 h-5 text-brand-accent" data-id="element-65" />
                hello@deskmayte.com
              </li>
              <li className="flex items-center gap-3" data-id="element-66">
                <Phone className="w-5 h-5 text-brand-accent" data-id="element-67" />
                +1 (555) 000-0000
              </li>
              <li className="flex items-center gap-3" data-id="element-68">
                <MapPin className="w-5 h-5 text-brand-accent" data-id="element-69" />
                Global Operations
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-slate-500" data-id="element-70">
          <p data-id="element-71">© 2026 Deskmayte. All rights reserved.</p>
          <div className="flex gap-8" data-id="element-72">
            <a href="#" className="hover:text-white transition-colors" data-id="element-73">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-74">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}